import type {ClientProfile} from '../types';

export const identityProfile: ClientProfile = {
  clientId: 'identity',
  theme: {
    appTitle: 'ID Channel Dashboard',
    brandName: 'ID Channel',
    logoUrl: '/assets/images/logo.png',
    primaryColor: '#1a71db',
    designSystem: {
      colors: { primary: '#1a71db', secondary: '#f2f3f5', grayText: '#333840', grayUnit: '#7a8699', error: '#e53e3e', warning: '#f59e42', success: '#22c55e' },
      typography: { fontFamily: 'Zain', fontFamilyHeading: 'Zain' },
      themeClass: 'theme-identity'
    }
  },
  enabledModules: [
    'dashboard',
    'map',
    'stores-map',
    'products',
    'inventory',
    'distribution',
    'marketers',
    'marketer-tracking',
    'service-providers',
    'stores',
    'store-deliveries',
    'visits',
    'payments',
    'sales',
    'users',
    'reports',
    'reports-marketer',
    'reports-products-sales',
    'provider',
    'add-stock'
  ],
  defaultLandingPath: '/dashboard',
  features: {
    serialsEnabled: true,
    inventoryEnabled: true,
  }
};
